<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright">
        <!-- © {{year}} made with <i class="tim-icons icon-heart-2"></i> by Totey, for a better administrative experience -->
        © {{year}} Worre Studio
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  };
</script>
<style>
</style>
